import "../CSS/zertifikate.css";

import Seo from "../components/Seo";


function ZertifikatePage() {

    const zertifikate = [

        {
            titel: "ITC Fundamental",
            bild: "/Zertifikate/itcjpg.jpg",
            datei: "/Zertifikate/zertifikat ITC.pdf"
        },

        {
            titel: "Eplan P8",
            bild: "/Zertifikate/p8.jpg",
            datei: "/Zertifikate/Zertifikat Eplan P8.pdf"
        },

        {
            titel: "Eplan Fluid",
            bild: "/Zertifikate/fluid.jpg",
            datei: "/Zertifikate/Zertifikat Eplan Fluid.pdf"
        },

        {
            titel: "SICK Workshop",
            bild: "/Zertifikate/sick.jpg",
            datei: "/Zertifikate/Zertifikat SICK.pdf"
        }

    ];


    return (

        <>

            <Seo
                title="Zertifikate"
                description="Zertifikate von Ivan Jörg aus den Bereichen Informatik, Eplan, Elektrotechnik und Automatisierung."
                canonical="https://www.irj.ch/zertifikate"
            />


            <div className="intro">

                <p>
                    Hier findest Du eine Auswahl meiner Zertifikate.
                </p>

            </div>


            <main>

                <div className="karten-container">

                    {
                        zertifikate.map(
                            (zertifikat, index) => (

                                <article
                                    className="content-card"
                                    key={index}
                                >

                                    <div className="card-bild">

                                        <img
                                            src={zertifikat.bild}
                                            alt={zertifikat.titel}
                                        />

                                    </div>


                                    <h2>
                                        {zertifikat.titel}
                                    </h2>


                                    <a
                                        className="card-button"
                                        href={zertifikat.datei}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Zertifikat öffnen
                                    </a>

                                </article>

                            )
                        )
                    }

                </div>

            </main>

        </>

    );
}


export default ZertifikatePage;